import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '../helpers/localStorage';
import { IN_TESTING_MODE, TEST_AUTH_TOKEN } from '../tests/constants';
import { ASSIST_BASE_URL } from './constants';
import { filterTotalLossAssistEvents } from './helpers';

// Define a service using a base URL and expected endpoints
export const assistApi = createApi({
  reducerPath: 'assistApi',
  baseQuery: fetchBaseQuery({
    baseUrl: ASSIST_BASE_URL,
    prepareHeaders: async (headers) => {
      // pass test token when running locally
      const token = IN_TESTING_MODE ? TEST_AUTH_TOKEN : await getAccessToken();
      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['UserUpdate', 'AdminUpdate'],
  endpoints: (builder) => ({
    getAdminAssistByOrgId: builder.query({
      query: ({ orgId }) => `adminassists/${orgId}`,
      providesTags: ['AdminUpdate'],
      transformResponse: (response, __, arg) => {
        const { hasTotalLossEnabled } = arg;
        if (!hasTotalLossEnabled) {
          return {
            ...response,
            data: filterTotalLossAssistEvents(response),
          };
        }
        return response;
      },
    }),
    getUserAssistRule: builder.query({
      query: ({ orgId, userId }) => `userassists/${orgId}/${userId}`,
      providesTags: ['AdminUpdate', 'UserUpdate'],
      transformResponse: (response, __, arg) => {
        const { hasTotalLossEnabled } = arg;
        if (!hasTotalLossEnabled) {
          return {
            ...response,
            data: filterTotalLossAssistEvents(response),
          };
        }
        return response;
      },
    }),
    updateUserAssistRule: builder.mutation({
      query: ({ eventTypeArray, orgId, userId }) => ({
        url: `userassists/update/${orgId}/${userId}`,
        method: 'PUT',
        body: eventTypeArray,
      }),
      invalidatesTags: ['UserUpdate'],
    }),
    updateAdminAssistRule: builder.mutation({
      query: ({ eventTypeArray, orgId }) => ({
        url: `adminassists/${orgId}`,
        method: 'PUT',
        body: eventTypeArray,
      }),
      invalidatesTags: ['AdminUpdate'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAdminAssistByOrgIdQuery,
  useGetUserAssistRuleQuery,
  useUpdateUserAssistRuleMutation,
  useUpdateAdminAssistRuleMutation,
} = assistApi;
